/**
 * Asserts that a value is not null and not undefined.
 * Throws an Error if it is.
 * Returns the value strictly typed if not.
 */
export function assertNotNullOrUndefined<T>(value: null | undefined | T): T {
    if (value === null || value === undefined) {
        throw new NotNullishAssertionError("Value is null or undefined");
    }

    return value;
}

/**
 * Alias for `assertNotNullOrUndefined`.
 */
export const assertDefined = assertNotNullOrUndefined;

export function assertNotNull<T>(value: null | T): T {
    if (value === null) {
        throw new NotNullAssertionError("Value is null");
    }

    return value;
}

export function assertNotUndefined<T>(value: undefined | T): T {
    if (value === undefined) {
        throw new NotUndefinedAssertionError("Value is undefined");
    }

    return value;
}

export function assertThat<T>(value: T, fn: (x: T) => boolean): T {
    if (fn(value) === false) {
        throw new TypeAssertionError("Value is null or undefined");
    }

    return value;
}

export class TypeAssertionError extends Error {
}

export class NotNullAssertionError extends TypeAssertionError {
}

export class NotUndefinedAssertionError extends TypeAssertionError {
}

export class NotNullishAssertionError extends TypeAssertionError {
}
